// Temporary file to keep player versions up to date with the storybook
// TODO: Always use the latest version in storybook/default config
export const playerPluginVersion = {
  shaka: '0.0.2',
  videoJs: '0.0.3',
  brightcove: '0.0.2',
  akamai: '0.4.2',
  jw: '0.0.3',
};
